import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import { ChatService } from '../services/chat.service';

/**
 * Imagem de anexo do chat carregada por HttpClient com `withCredentials`
 * (`ChatService.getImage`): `GET {chat}/chatv2/chat/file/<nome>` é guardado pelo
 * cookie do CRM, que um `<img src>` cruzado não envia. Cópia da diretiva da
 * PWA (`[appAuthImage]`), a trocar o ChatImageService pelo serviço do CRM.
 *
 * `string | undefined` de propósito: a mensagem em envio só tem `nameTemp`
 * (pré-visualização local, data URL), e pode não ter nada.
 */
@Directive({
  selector: '[appAuthImage]'
})
export class ChatAuthImageDirective implements OnChanges {
  @Input('appAuthImage') imageUrl?: string;

  private lastUrl?: string;

  constructor(
    private el: ElementRef,
    private chatService: ChatService
  ) {}

  ngOnChanges(): void {
    // O placeholder passa de data URL (local) a URL do servidor quando o envio
    // termina; com OnInit só se carregava a primeira.
    if (this.imageUrl !== this.lastUrl) {
      this.lastUrl = this.imageUrl;
      this.loadImage(this.imageUrl);
    }
  }

  private loadImage(url?: string): void {
    // Sem URL (anexo ainda a subir, ou mensagem sem ficheiro): deixa-se o
    // elemento como está. Pedir '' dava 404 e apagava a pré-visualização.
    if (!url) {
      return;
    }

    // Uma data URL é a pré-visualização do FileReader antes de o envio acabar:
    // não precisa de sessão e não pode passar pelo HttpClient.
    if (url.indexOf('data:') === 0) {
      this.apply(url);
      return;
    }

    const requested = url;
    this.chatService.getImage(url).subscribe({
      next: (blob: Blob) => {
        const reader = new FileReader();
        reader.onload = () => {
          if (this.lastUrl === requested) {
            this.apply(reader.result as string);
          }
        };
        reader.readAsDataURL(blob);
      },
      error: (error: any) => {
        console.error('Error loading image:', error);
      }
    });
  }

  private apply(src: string): void {
    const img: HTMLImageElement = this.el.nativeElement;
    img.src = src;
    const parent = img.parentElement as HTMLAnchorElement | null;
    if (parent && parent.tagName === 'A') {
      parent.href = src;
    }
  }
}
